import { Outlet } from 'react-router-dom'
import InAppMeetingPanel from '@/components/InAppMeetingPanel'
import { HelpAgentRoot } from '@/components/HelpAgent'
import ProvisionalBoardSweeper from '@/routes/IntelligentBoard/ProvisionalBoardSweeper'
import { useFeatureAccess } from '@/features/featureAccess/useFeatureAccess'
import { useAppStore } from '@/store'

// Top-level layout that wraps every route so cross-route surfaces
// (e.g. the in-app meeting PiP panel, the help agent) survive navigation.
export const RootLayout = () => {
  const { isEnabled, loaded: featuresLoaded } = useFeatureAccess()
  // A call already running keeps its panel (and its end control) even if calls get hidden.
  const callActive = useAppStore((s) => s.activeToken !== null)
  return (
    <>
      <Outlet />
      {(isEnabled('agent_calls') || callActive) && <InAppMeetingPanel />}
      {/* Wait for this person's list: until it loads every area reads as on,
          so a person the help agent is hidden from would see it flash. The
          list fails open on error, so this never keeps it hidden for good. */}
      {featuresLoaded && isEnabled('help_agent') && <HelpAgentRoot />}
      {/* UI-84: watches for the user leaving a board. Lives here because this
          layout survives navigation — the board canvas itself unmounts for
          reasons that are not a departure. */}
      <ProvisionalBoardSweeper />
    </>
  )
}
